module.exports = __webpack_public_path__ + "static/media/GTRKLogo.1aea96d5.jpg";